// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1SCVs","footer":"ReportModalFilter_footer__16uIX"};